import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import ElementPlus from "element-plus";
import axios from "axios";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "element-plus/dist/index.css";
import ArgonDashboard from "./argon-dashboard";
import VTooltip from "v-tooltip";
import { MotionPlugin } from "@vueuse/motion";

// Configuración global de Axios
axios.defaults.baseURL = "https://gateway.banagua.com:12000/gateway/Security";
axios.defaults.withCredentials = true;
axios.defaults.timeout = 5000;

axios.interceptors.request.use(
  function (config) {
    const token = store.getters["auth/getToken"];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(undefined, function (error) {
  const originalRequest = error.config;
  if (
    error.response?.status === 401 &&
    originalRequest &&
    !originalRequest._retry
  ) {
    originalRequest._retry = true;
    store.dispatch("auth/logout");
    router.push("/signin");
  }
  return Promise.reject(error);
});

const appInstance = createApp(App);
appInstance.use(VTooltip);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ElementPlus);
appInstance.use(ArgonDashboard);
appInstance.use(MotionPlugin);
appInstance.mount("#app");
